// Project 750k App Exports
import Project750kApp from './Project750kApp';
import UccDataViewer from './pages/UccDataViewer';
import UccDataViewerListC from './pages/UccDataViewerListC';
import DebtorLookup from './pages/reports/DebtorLookup';
import RegionalAnalysis from './pages/reports/RegionalAnalysis';
import TopDebtors from './pages/reports/TopDebtors';
import SecuredPartyAnalysis from './pages/reports/SecuredPartyAnalysis';
import AmendmentTrends from './pages/reports/AmendmentTrends';

// Export Dashboard as the main component
export const Dashboard = Project750kApp;

// Export UCC Data Viewers
export { UccDataViewer };
export { UccDataViewerListC };

// Export Report Pages
export { DebtorLookup };
export { RegionalAnalysis };
export { TopDebtors };
export { SecuredPartyAnalysis };
export { AmendmentTrends };

